import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { TokenService } from "../../core/token/token.service";
import { User } from "../../core/user/user";
import { BehaviorSubject, Observable } from "rxjs";
import jwt_decode from 'jwt-decode';
import { UserService } from "../../core/user/user.service";

@Component({
  selector: 'erpcloud-dash',
  standalone: false,
  templateUrl: './dash.component.html',
  styleUrls: ['./dash.component.css']
})
export class DashComponent {
  user$: Observable<User | null>;
  userInfo?: User | null = null;
  userName: string = "";

  constructor( private readonly userService: UserService, private router: Router ) {
    this.user$ = this.userService.getUser();

      this.user$.subscribe(x => {
      this.userInfo = x,
        this.userName = x?.name as string
      })
  }

  redirect(url: string) {
    console.log("Redirecting to: ", url);
    this.router.navigate([url]);
  }
}
